import React, {PropsWithChildren, ReactElement, useMemo, useState} from "react";
import {Route, RouteProps, useHistory} from "react-router-dom";
import {useGatedAccess} from "@carvana/core-auth";

type GatedRouteProps = RouteProps & PropsWithChildren<{
  placeholder?: ReactElement;
}>;

function DefaultPlaceholder() {
  const styles = {
    width: '100vw',
    height: '50vh',
    background: 'var(--cvna-color-grey-1)'
  };

  return <div style={styles} />
}

export default function GatedRoute({ children, placeholder = <DefaultPlaceholder />, ...rest }: GatedRouteProps) {
  const [shouldRender, setShouldRender] = useState(false);
  const gate = useGatedAccess();
  const history = useHistory();

  const onSuccess = () => {
    if(!shouldRender) setShouldRender(true);

    return <>{children}</>;
  }

  const onFailure = () => history.replace('/')

  const visibleComponent = useMemo(() => gate('MyCars Router Instance', onSuccess, onFailure) || placeholder, [shouldRender]);

  return <Route {...rest} children={() => visibleComponent} />
}